import { getBaseUrl, Microservice } from "../constant/baseUrl";
import { getApiResponseErrorMsg } from "../Utils/apiHelper";
import axios from "axios";

export interface EditSkuPoOcrColumnRequest {
  ids: number[];
  token: string;
  column: string;
  value: string;
}

const editSkuPoOcrColumn = async ({
  ids,
  token,
  column,
  value,
}: EditSkuPoOcrColumnRequest) => {
  try {
    const response = await axios.post(
      `${getBaseUrl(Microservice.SKU_FINANCE)}/sku-finance/loan-application/edit-sku-po-ocr-column`,
      { ids, column, value },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

export default editSkuPoOcrColumn;
